import React, { useEffect, useState } from 'react';
import { Button, LayerBottom } from 'components'
import useApp from 'hooks/useApp'

const TermsCheck = () => {

	const App = useApp()
	const [filterLayer, setFilterLayer] = useState(false)

	const openFilter = () => {
		setFilterLayer(true)
	}

	const closeFilter = () => {
		setFilterLayer(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				<h3>서비스 이용약관</h3>
				<div className="terms-txt mt_20">
					약관내용약관내용약관내용약관내용약관내용약관내용약관
					내용약관내용약관내용약관내용약관내용약관내용약관내용
				</div>
				<div className="flex-justify_between align_center mt_40">
					<span style={{ color: "#999" }}>이전약관보기</span>
					<span className="flex-align_center" onClick={openFilter}>2021.01.20 <i className="icon icon_arrow_sm bottom ml_15" /></span>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">확인</Button>
			</div>

			<FilterLayer show={filterLayer} closeLayer={closeFilter} />
		</div>
	)
}

const FilterLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom title="이전 약관 보기" show={show} closeLayer={closeLayer}>
			<ul className="select-list">
				<li className="on">2021.05.01</li>
				<li>2021.06.30</li>
				<li>2022.02.05</li>
			</ul>
		</LayerBottom>
	)
}

export default TermsCheck